var path = '/var/www/mmscny-website/src/app/common/components/feature-description-page-template/feature-description-page-template.html';
var html = "<div class=\"col-md-12 col-xs-12 col-sm-12 col-lg-12 features-description\"> <div class=container> <div class=\"col-md-12 col-xs-12 col-sm-12 col-lg-12 feature no-padding\"> <p ng-bind-html=$ctrl.details.description></p> </div> </div> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/common/components/feature-description-page-template/feature-description-page-template.html
// module id = 646
// module chunks = 0